import { render } from "./PlaceHead.vue?vue&type=template&id=700d2008"
import script from "./PlaceHead.vue?vue&type=script&lang=js"
export * from "./PlaceHead.vue?vue&type=script&lang=js"

import exportComponent from "/home/orderadmin/domains/app.orderadmin.ru_build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';import Morph from 'quasar/src/directives/Morph.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QBadge,QIcon,QCard,QCardSection});qInstall(script, 'directives', {Morph});
